<template>
  <vue-plyr ref="plyr" id="video-player">
    <video v-bind:poster="thumb" v-bind:src="path" @ended="ended" v-show="show"></video>
    <table class="afterVideo" v-show="!show">
      <tr>
        <td>
          <router-link
            v-if="prevVideo"
            @click="play"
            :to="{name: 'video', params: {id: prevVideo.id}}"
            class="plyr__controls__item plyr__control controlButton"
          >
            <svg role="presentation" focusable="false">
              <use xlink:href="#plyr-rewind" />
            </svg>
            <span class="plyr__sr-only">Previous</span>
          </router-link>
        </td>
        <td>
          <button v-on:click="play" type="button" class="plyr__control" aria-label="Play">
            <svg role="presentation" focusable="false">
              <use xlink:href="#plyr-play" />
            </svg>
            <span class="plyr__sr-only">Play</span>
          </button>
        </td>

        <td>
          <router-link
            v-if="nextVideo"
            @click="play"
            :to="{name: 'video', params: {id: nextVideo.id}}"
            class="plyr__controls__item plyr__control controlButton"
          >
            <svg role="presentation" focusable="false">
              <use xlink:href="#plyr-fast-forward" />
            </svg>
            <span class="plyr__sr-only">Next</span>
          </router-link>
        </td>
      </tr>
      <tr>
        <td>{{prevVideo && prevVideo.name}}</td>
        <td></td>
        <td>{{nextVideo && nextVideo.name}}</td>
      </tr>
    </table>
  </vue-plyr>
</template>

<style lang="less" scoped>
.afterVideoWrapper {
  width: 100%;
  height: 100%;
}

.afterVideo {
  max-width: 100%;
  margin: 30% auto;
  text-align: center;
  table-layout: fixed
}

.afterVideo td {
    width: 33%;
}

.controlButton svg {
  display: inline;
}

</style>

<script>
export default {
  mounted() {},
  data: () => ({
    show: true
  }),
  props: ["thumb", "path", "nextVideo", "prevVideo"],
  computed: {
    player() {
      return this.$refs.plyr.player;
    }
  },
  methods: {
    ended() {
      this.show = false;
    },
    play(event) {
      event.preventDefault();
      this.show = true;
      if (this.player) {
        this.player.play();
      }
      return false;
    }
  }
  //   updated: function() {
  //     this.$nextTick(function() {
  //       const videoplayer = document.getElementById("video-player");
  //       if (!this.playerInitialized) {
  //         videoplayer.addEventListener("ready", event => {
  //           this.player = this.$refs.plyr.player;
  //         });
  //       }
  //     });
  //   }
};
</script>



// WEBPACK FOOTER //
// src/public_app/pages/videozone/VideoPlayer.vue